import React from 'react';
import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { MeasureResultsModel } from './MeasureResultsModel';

interface IMeasureResultsViewProps {
  measureResults: MeasureResultsModel;
}

export const MeasureResultsView = observer(function (props: IMeasureResultsViewProps) {
  return (
    <Fragment>
      {props.measureResults.displayResult !== undefined && (
        <div>
          <div>
            {props.measureResults.displayResult.lengthText !== undefined &&
              `Distance: ${props.measureResults.displayResult.lengthText}`}
          </div>
          <div>
            {props.measureResults.displayResult.areaText !== undefined &&
              `Area: ${props.measureResults.displayResult.areaText}`}
          </div>
          <div>
            {props.measureResults.displayResult.perimeterText !== undefined &&
              `Perimeter: ${props.measureResults.displayResult.perimeterText}`}
          </div>
        </div>
      )}
    </Fragment>
  );
});
